import { METHOD_EPAYMENT, STATUS_CANCELLED } from 'constants';
import useFxAddTransaction, {
  FX_ADD_TRANSACTION_TOTAL_NUMBER_OF_STEPS_AS_GUEST,
} from 'hooks/fx/useFxAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import React, { useEffect, useRef } from 'react';

const withFxMakePaymentAsGuest = (Component) => {
  const FxMakePaymentAsGuestComponent = (props) => {
    const { isMakePaymentAsGuest } = useFxAddTransaction();
    const {
      transactionDetails,
      paymentMethodName,
      setAddTransactionCurrentStep,
      isShowPaymentInstruction,
    } = useFxFormAddTransactionStore();

    const isOpenFormPaymentByDepositInitial = useRef();

    const isOrderCancelled =
      transactionDetails?.orderStatus === STATUS_CANCELLED;

    const { isAllowOrderMakePayment, isMakePaymentExpired, onPayProcess } =
      props || {};

    useEffect(() => {
      if (!isMakePaymentAsGuest) return;
      if (isMakePaymentExpired) return;
      if (isOrderCancelled) return;
      if (!isAllowOrderMakePayment && !isShowPaymentInstruction) {
        setAddTransactionCurrentStep(
          FX_ADD_TRANSACTION_TOTAL_NUMBER_OF_STEPS_AS_GUEST
        );
        return;
      }
      if (!isAllowOrderMakePayment) return;
      if (isOpenFormPaymentByDepositInitial.current) return;
      if (paymentMethodName === METHOD_EPAYMENT) {
        onPayProcess();
        isOpenFormPaymentByDepositInitial.current = true;
      }
    }, [
      isMakePaymentAsGuest,
      isMakePaymentExpired,
      isAllowOrderMakePayment,
      paymentMethodName,
      isOpenFormPaymentByDepositInitial,
      isShowPaymentInstruction,
      isOrderCancelled,
    ]);

    const newProps = {
      ...props,
    };
    return <Component {...newProps} />;
  };
  return FxMakePaymentAsGuestComponent;
};

export default withFxMakePaymentAsGuest;
